import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  ThreatGroupTooltipsBullet,
  ThreatGroupTooltipsDescription,
  ThreatGroupTooltipsStyled,
  ThreatGroupTooltipsBullets,
} from '../ThreatGroupTooltip.styled'

export const InvalidBotActivity = () => {
  const { t } = useTranslation('botMitigation')
  return (
    <ThreatGroupTooltipsStyled>
      <ThreatGroupTooltipsDescription>
        {t('threatGroups.tooltips.invalidBotActivity.description')}
      </ThreatGroupTooltipsDescription>
      <ThreatGroupTooltipsBullets>
        <ThreatGroupTooltipsBullet>
          {t('threatGroups.tooltips.invalidBotActivity.malicious_bots')}
        </ThreatGroupTooltipsBullet>
        <ThreatGroupTooltipsBullet>
          {t('threatGroups.tooltips.invalidBotActivity.automation_tools')}
        </ThreatGroupTooltipsBullet>
        <ThreatGroupTooltipsBullet>
          {t('threatGroups.tooltips.invalidBotActivity.scrapers')}
        </ThreatGroupTooltipsBullet>
        <ThreatGroupTooltipsBullet>
          {t('threatGroups.tooltips.invalidBotActivity.spam_bots')}
        </ThreatGroupTooltipsBullet>
        <ThreatGroupTooltipsBullet>
          {t('threatGroups.tooltips.invalidBotActivity.account_take_over')}
        </ThreatGroupTooltipsBullet>
      </ThreatGroupTooltipsBullets>
    </ThreatGroupTooltipsStyled>
  )
}
